import React from "react";


function Experience(){
    return(
        <div id = "experience">
            <h1>Experience</h1>

            <div id = "EXE">
                <h6>2021 - Present</h6>
                <p>.Exe || Technical club of NIT Hamirpur</p>
                <p>Volunteer ||</p>
                <p>Full Stack Developer</p>
            </div>

            <div id = "PR">
            <h6>2021 - Present</h6>
                <p>.PR || A club for managing and hosting events</p>
                <p>Volunteer ||</p>
                <p>Writer, Anchor</p>
            </div>
            <div id = "Lean-In">
                <h6>2021 - Present</h6>
                <p>Lean In @ NITH</p>
                <p>Community for women in tech at NITH</p>
            </div>
            <div id = "IOTIOT">
                <h6>19 - 21 March, 2021</h6>
                <p>Pre Office hands-on workshop ||</p>
                <p>IoTIoT</p>
            </div>
        </div>
    
    )
}

export default Experience;